/*
 * View for the topic label modal
 */

define(["marionette", "./template/contentAndLearnerTemplate.html"], function (
  Marionette,
  ContentAndLearnerTemplate,
) {
  var ContentAndLearnerView = {};

  ContentAndLearnerView.contentAndLearnerView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: ContentAndLearnerTemplate,
    triggers: {
      "click #chkEnableContentTab": "click:enableContentTab",
      "click #chkEnableLearnerTab": "click:enableLearnerTab",
      "click #chkEnableSubstitutionsTab": "click:enableSubstitutionsTab",
      "click #chkTaskCreate": "click:taskCreate",
      "click #chkEditAnyTask": "click:editAnyTask",
      "click #chkResponseReview": "click:responseReview",
    },
  });

  return ContentAndLearnerView;
});
